import { getPlural, getStatusBadge } from "@helpers/utils";

import { Badge } from "reactstrap";
import { DATE_FORMAT_VIEW } from "@src/utility/constants";
import Flex from "@components/ui-components/flex";
import LoadingButton from "@components/ui-components/loading-button";
import LongNameFormatter from "@components/formatters/long-name-formatter";
import capitalize from "lodash/capitalize";
import size from "lodash/size";
import useDateHandler from "@src/utility/hooks/use-date-handler";
import { useTranslation } from "react-i18next";

export const decoColumns = ({ handleRowActions, handleStatus }) => {

    const { t } = useTranslation();
    const { dateFormatter } = useDateHandler();

    return [
        {
            name    : "Name",
            selector: (row) => row.name,
            width   : "250px",
            cell    : (row) => (
                <LongNameFormatter
                    content={row.name}
                    className="fw-bold"
                    id={`name-${row._id}`}
                    max={35}/>
            )
        },
        {
            name    : "Description",
            selector: (row) => row.description,
            width   : "350px",
            cell    : (row) => (
                <LongNameFormatter
                    content={row.description}
                    id={`description-${row._id}`}
                    max={35}/>
            )
        },
        {
            name    : "Status",
            selector: (row) => row.status,
            width   : "100px",
            cell    : (row) => (
                <Badge color={getStatusBadge(row.status)?.color}>
                    {t(getStatusBadge(row.status)?.title)}
                </Badge>
            )
        },
        {
            name    : "Flow Steps",
            selector: (row) => row.flow_steps,
            width   : "150px",
            cell    : (row) => (
                <p className="text-xl font-semibold">
                    {size(row.flow_steps)}{" "}
                    <span className="text-xs font-medium text-gray-500">
                        {t(getPlural({ text: "Step", length: size(row.flow_steps) }))}
                    </span>
                </p>
            )
        },
        {
            name    : "Created At & Created By",
            selector: (row) => row.created_by.name,
            width   : "250px",
            cell    : (row) => <Flex column>
                <p>
                    <i className="mdi mdi-calendar me-1 font-medium-2" />
                    {dateFormatter({
                        date    : row?.created_at,
                        formatAs: DATE_FORMAT_VIEW
                    })}
                </p>
                <p>
                    <i className="mdi mdi-account-circle me-1 font-medium-2" />
                    {capitalize(row.created_by.name)}</p>
            </Flex>
        },
        {
            name : "Actions",
            width: "250px",
            cell : (row) => {
                const isActive = row.status === "active";
                return (
                    <Flex>
                        <LoadingButton
                            outline
                            color="warning"
                            id={`${row._id}-status-button`}
                            icon={isActive ? "stop-circle" : "play-circle"}
                            tooltip={
                                t(`Are you sure you want to ${!isActive ? "start" : "stop"} this playbook?`)
                            }
                            onClick={() => handleStatus(row._id, isActive)}/>

                        <LoadingButton
                            outline
                            color="info"
                            id={`${row._id}-edit-button`}
                            icon="pencil"
                            onClick={() => handleRowActions(row, "edit")}/>
                        <LoadingButton
                            outline
                            color="danger"
                            id={`${row._id}-delete-button`}
                            icon="delete"
                            onClick={() => handleRowActions(row, "delete")}/>
                    </Flex>
                );
            }
        }
    ];
};
